module.exports = __webpack_public_path__ + "img/category-management-icon8.fe4097e9.svg";